import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import KarleAddProducts from "./KarleAddProducts";
import KarleMenuTab from "./KarleMenuTab";
import KarleAdminTab from "./KarleAdminTab";
import KarleSalesOrdersTab from "./KarleSalesOrdersTab";
import KarleProductionTab from "./KarleProductionTab";

const KarleMenuPage = () => {
  return (
    <div>
      <h2 className="header-c mb-4">Karle Menu</h2>
      <Tabs defaultActiveKey="add-products" className="mb-3">
        <Tab eventKey="add-products" title="Add Products">
          <KarleAddProducts />
        </Tab>
        <Tab eventKey="menu" title="Menu">
          <KarleMenuTab />
        </Tab>
        <Tab eventKey="karle-admin" title="Karle Admin">
          <KarleAdminTab />
        </Tab>
        <Tab eventKey="sales-orders" title="Karle Sales Orders">
          <KarleSalesOrdersTab />
        </Tab>
        <Tab eventKey="production" title="Production">
          <KarleProductionTab />
        </Tab>
      </Tabs>
    </div>
  );
};

export default KarleMenuPage;
